import styled, { css } from 'styled-components';

import refresh from '~/assets/icons/refresh.svg';
import star from '~/assets/icons/star.svg';
import expStar from '~/assets/icons/star_exp.svg';
import taskBg from '../../assets/images/task_bg.png';

import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div<{ $fixedWidth?: boolean; $span?: number }>`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 20px;
	grid-column: span ${(props) => props.$span || 1};
	${(props) =>
		props.$fixedWidth
			? css`
					width: 600px;
			  `
			: css`
					min-width: 600px;
			  `}
	height: 238px;
	padding: 20px;
	border-radius: 5px;
	background: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.1);
	background-image: url(${taskBg});
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-position: center;
	transition: opacity 0.3s ease;

	@media (max-width: 1500px) {
		min-width: 400px;
	}

	&.task-enter {
		opacity: 0;
	}

	&.task-enter-active,
	&.task-enter-done,
	&.task-exit {
		opacity: 1;
	}

	&.task-exit-active {
		opacity: 0;
	}

	& > ${Text} {
		flex: 1;
		font-size: 16px;
		color: #ffffff;
		opacity: 0.5;
	}

	${Divider} {
		opacity: 0.1;
	}
`;

const StyledBackground = styled.div<{ $progress: number }>`
	position: absolute;
	top: 0;
	left: 0;
	width: ${(props) => props.$progress}%;
	height: 100%;
	border-radius: ${(props) =>
		props.$progress === 100 ? '4px' : '4px 0 0 4px'};
	background-color: rgba(255, 181, 0, 0.2);
`;

const StyledTopContainer = styled.div`
	display: flex;
	justify-content: space-between;
`;

const StyledStar = styled.img.attrs({ src: star })<{ $pinned: boolean }>`
	width: 14px;
	height: 14px;
	transition: opacity 0.3s ease;
	user-select: none;

	${(props) =>
		props.$pinned
			? css`
					opacity: 1;
			  `
			: css`
					opacity: 0.5;

					&:hover {
						opacity: 1;
					}
			  `}
`;

const StyledIconButtonWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	cursor: pointer;

	&:hover {
		img {
			opacity: 1;
		}
	}
`;

const StyledRefresh = styled.img.attrs({ src: refresh })`
	width: 14px;
	height: 14px;
	opacity: 0.5;
	transition: opacity 0.3s ease;
	user-select: none;
	cursor: pointer;

	&:hover {
		opacity: 1;
	}
`;

const StyledBottomContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledRewardsContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 20px;
	font-size: 16px;
	font-weight: 700;
`;

const StyledRewardContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 10px;
	user-select: none;
	pointer-events: none;

	${Text} {
		font-size: 16px;
		font-weight: 700;
	}
`;

const StyledDot = styled.div`
	width: 6px;
	height: 6px;
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 50%;
`;

const StyledControlsContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	height: 14px;
	margin-right: -5px;
`;

const StyledXPStar = styled.div`
	width: 14px;
	height: 14px;
	mask-image: url(${expStar});
	mask-position: center;
	mask-repeat: no-repeat;
	-webkit-mask-image: url(${expStar});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	background-color: #ffb500;
`;

export {
	StyledBackground,
	StyledBottomContainer,
	StyledContainer,
	StyledControlsContainer,
	StyledDot,
	StyledIconButtonWrapper,
	StyledRefresh,
	StyledRewardContainer,
	StyledRewardsContainer,
	StyledStar,
	StyledTopContainer,
	StyledXPStar,
};
